import { types } from "mobx-state-tree";
import { DataGridStorageModel } from "../../components/datatable/DataGridStorage";
import { Column, ColumnType } from "../../components/datatable/interfaces";
import { endpoints } from "../api/ApiEndpoints";
import { VaUsagePerBillingCycleResponse } from "../../api-models/response/user/VaUsagePerBillingCycleResponse";
import { VaUsagePerBillingCycle } from "./VaUsagePerBillingCycle";

const VideoAnalysisCallUsageModel = types.model({
  userId: types.number,
});

export const UsersVaUsageStorageModel = types
  .compose(DataGridStorageModel, VideoAnalysisCallUsageModel)
  .named("JobsStorageModel")
  .views(() => ({
    get tableColumns(): Column[] {
      return [
        {
          key: "billingCycle",
          name: "general.users-va-usage.list-header.billing-cycle",
          type: ColumnType.DateTime,
          sortable: true,
          filterable: true,
        },
        {
          key: "billingPeriodStart",
          name: "general.users-va-usage.list-header.billing-period-start",
          type: ColumnType.DateTime,
          sortable: true,
          filterable: true,
        },
        {
          key: "billingPeriodEnd",
          name: "general.users-va-usage.list-header.billing-period-end",
          type: ColumnType.DateTime,
          sortable: true,
          filterable: true,
        },
        {
          key: "totalVaCalls",
          name: "general.users-va-usage.list-header.total-va-calls",
          type: ColumnType.Number,
          sortable: true,
          filterable: true,
        },
      ];
    },
  }))
  .actions((self) => {
    return {
      afterCreate() {
        self.gridColumns = self.tableColumns;
      },
      mapItem(item: VaUsagePerBillingCycleResponse) {
        return new VaUsagePerBillingCycle(item);
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("video_analysis_usage_per_user");
      endpoint.routeParams = [self.userId];
      endpoint.queryParams = self.getDataQuery();
      return endpoint;
    },
  }));
